import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const validatePlatformNameFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'validate-platform-name-form-field-extension',
    params: {
      field: () =>
        import('./validate-platform-name').then(
          m => m.ValidatePlatformNameFormField,
        ),
    },
  });
